// extracted by mini-css-extract-plugin
export default {"header":"MotorsTable_header__fGSq6","body":"MotorsTable_body__sKPuX","error":"MotorsTable_error__D2dWd"};